import { useMsal } from '@azure/msal-react';
import { Box, Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Typography, useTheme } from '@mui/material';
import { isMobileView, useAlerts, useFormCollection } from '@sis/react-library';
import { useState } from 'react';
import { commonRoutes } from '../shared/commonRoutes';
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';

export const LayoutTopAppBarRight = () => {

  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);

  const { instance, accounts } = useMsal();
  const { confirm, alert } = useAlerts();
  const theme = useTheme();
  const isMobile = isMobileView();

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const { disableFormLeavePrompt } = useFormCollection();

  const handleLogout = () => {
    setAnchorElUser(null);
    if (accounts && accounts.length) {
      logout();
    } else {
      alert('Logout',
        <Box>
          You are not using AD authentication in this sample so can't logout.<br />If you wish to test 
          this functionailty change the <b>USE_AD_AUTHENTICATION</b> variable to true in <b>'App.tsx'"</b>.
        </Box>
      );
    }
  }

  const logout = () => {
    confirm('Logout', 'Are you sure you want to logout?',
      async () => {
        // Don't prompt that changes have been made to any form open, the person has already confirmed to logout
        await disableFormLeavePrompt();
        instance.logoutRedirect({
          postLogoutRedirectUri: commonRoutes.login,
        })
      }
    )
  }

  const username = accounts && accounts.length > 0 ? accounts[0].name : '[not using ad authentication]';

  return (
    <>
      <Box sx={{ display: 'flex' }}>
        {!isMobile &&
          <Typography id="menu-username" sx={{ padding: '4px 8px 0 0' }}>{username}</Typography>
        }
        <IconButton id="menu-icon" onClick={handleOpenUserMenu} sx={{ p: 0 }}>
          <PersonIcon
            sx={{
              color: theme.palette.common.white,
              fontSize: 28
            }}
          />
        </IconButton>
      </Box>
      <Menu
        sx={{ mt: '45px' }}
        id="menu-appbar"
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        <Typography id="submenu-username" sx={{ padding: '10px 16px 10px 16px', fontWeight: 'bold' }}>{username}</Typography>
        <Divider sx={{ marginBottom: '10px' }} />
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Logout</ListItemText>
        </MenuItem>
      </Menu>
    </>
  )
}
